module.exports = __webpack_public_path__ + "07c1b3eb376a491d2c3dfc43172d2047.MP3";